<ng-container *ngIf="isSmallScreen; else largeScreen">
  <dx-data-grid class="p-1 data-grid" id="gridContainer" [dataSource]="MaSvc.dataSource" [showBorders]="true" [remoteOperations]="true"
    [rowAlternationEnabled]="true"
    dataRowTemplate="dataRowTemplateName">
    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
    <dxi-column dataField="When" [caption]="'when' | translateWithFallback" dataType="datetime" format="dd.MM.yyyy hh:mm:ss.SSS" sortOrder="desc" width="33%"></dxi-column>
    <dxi-column dataField="ActivityType" [caption]="'type' | translateWithFallback" dataType="string" width="33%"> </dxi-column>
    <dxi-column dataField="InfoLevel" [caption]="'level' | translateWithFallback" dataType="string" width="34%"> </dxi-column>

    <tr *dxTemplate="let activity of 'dataRowTemplateName'" role="row" [ngClass]="{ 'dx-row-alt': activity.rowIndex % 2 === 0 }">
      <td colspan="3">
        <table width="100%" >
          <tr class="main-row" role="row">
            <td role="gridcell" width="30%">
              <dx-button stylingMode="text" (click)="show(activity.rowIndex)">
                <fa-icon *ngIf="!isShowed[activity.rowIndex]" [icon]="faAngleRight"></fa-icon>
                <fa-icon *ngIf="isShowed[activity.rowIndex]" [icon]="faAngleDown"></fa-icon>
              </dx-button>
            </td>
            <td role="gridcell" width="35%">{{ activity.data.ActivityType }}</td>
            <td role="gridcell" width="35%">{{ activity.data.InfoLevel }}</td>
          </tr>
          <tr *ngIf="isShowed[activity.rowIndex]">
            <td colspan="3">
              <table width="100%">
                <tr class="main-row" role="row">
                  <td role="gridcell">{{ activity.data.When | date:'dd.MM.yyyy hh:mm:ss.SSS' }}</td>
                  <td role="gridcell">{{ activity.data.ActivityType }}</td>
                </tr>
                <tr class="notes-row" role="row">
                  <td role="gridcell" colspan="2">{{ activity.data.InfoLevel }}</td>
                </tr>
                <tr class="notes-row" role="row">
                  <td role="gridcell" colspan="2">{{ activity.data.Text }}</td>
                </tr>
                <tr class="notes-row" role="row">
                  <td role="gridcell" colspan="2">{{ activity.data.Tags }}</td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>

    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-paging [pageSize]="25"> </dxo-paging>
    <dxo-pager [visible]="true" [showInfo]="true"
      [showNavigationButtons]="true"
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[10, 25, 50, 100]">
    </dxo-pager>
  </dx-data-grid>
</ng-container>

<ng-template #largeScreen>
  <dx-data-grid 
    class="p-1"
    id="gridActivityContainer"
    [dataSource]="MaSvc.dataSource"
    [showBorders]="true"
    [remoteOperations]="true"
    [rowAlternationEnabled]="true"
    [columnHidingEnabled]="true"
    [columnAutoWidth]="true"
    >
    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
    <dxi-column dataField="When" [caption]="'when' | translateWithFallback" dataType="datetime" format="dd.MM.yyyy hh:mm:ss.SSS" sortOrder="desc"> </dxi-column>
    <dxi-column dataField="ActivityType" [caption]="'type' | translateWithFallback" dataType="string" [hidingPriority]="2"> </dxi-column>
    <dxi-column dataField="InfoLevel" [caption]="'level' | translateWithFallback" dataType="string" [hidingPriority]="3"> </dxi-column>
    <dxi-column dataField="Text" [caption]="'text' | translateWithFallback" dataType="string" [hidingPriority]="1"></dxi-column>
    <dxi-column dataField="Tags" [caption]="'tags' | translateWithFallback" dataType="string" [allowFiltering]="false" [allowSorting]="false" [hidingPriority]="0"> </dxi-column>

    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-scrolling rowRenderingMode="virtual" mode="infinite"> </dxo-scrolling>
    <dxo-paging [pageSize]="25"> </dxo-paging>
    <dxo-pager 
      [visible]="true"
      [showInfo]="true"
      [showNavigationButtons]="true"
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[10, 25, 50, 100]">
    </dxo-pager>
  </dx-data-grid>
</ng-template>

